import { PlaneView } from '~/engine/view/views/PlaneView';
import CircleRegionOverlay from './Intensity/CircleRegionOverlay';
import LineProfileOverlay from './Intensity/LineProfileOverlay';
import MeasurementOverlay from './Measurement/MeasurementOverlay';

interface AnnotationOverlaysProps {
    view: PlaneView | null;
}

/**
 * The annotation overlays a view host shows: the measurements, the line
 * profiles and the circle regions, each in its own click-through SVG layer
 * over the view. Every host of a view mounts this once, so an annotation is
 * drawn wherever its series and orientation are shown and each overlay
 * applies its own membership rule.
 */
export default function AnnotationOverlays({ view }: AnnotationOverlaysProps) {
    return (
        <>
            <MeasurementOverlay view={view} />
            <LineProfileOverlay view={view} />
            <CircleRegionOverlay view={view} />
        </>
    );
}
